var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{class:[_vm.worklogsView ? 'user-td' : 'first-column']},[_vm._v("\n    "+_vm._s(_vm.userName)+"\n    "),(_vm.removeOption)?_c('i',{staticClass:"fa fa-times remove-icon",attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.deleteUser(_vm.userId)}}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }